import type { PricingData } from '@/content/types';

export default function Pricing(props: PricingData) {
  return (
    <section className="section-padding">
      <div className="container">
        <h2 className="h-section" style={{ textAlign: 'center', maxWidth: 800, margin: '0 auto' }}>
          {props.title}
        </h2>
        {props.subtitle && (
          <p style={{ textAlign: 'center', marginTop: 12, color: 'var(--color-muted)' }}>{props.subtitle}</p>
        )}
        <div className="pricing-grid" style={{ marginTop: 48 }}>
          {props.tiers.map((t, i) => (
            <div
              key={i}
              style={{
                padding: 28,
                borderRadius: 16,
                background: t.featured ? '#fff' : 'rgba(255, 255, 255, 0.6)',
                boxShadow: t.featured ? '0 10px 30px rgba(0,0,0,.08)' : 'none',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <div style={{ fontSize: 14, color: 'var(--color-muted)' }}>{t.name}</div>
              <div style={{ fontSize: 40, fontWeight: 800, marginTop: 8 }}>{t.price}</div>
              <ul style={{ marginTop: 24, listStyle: 'none', padding: 0, flex: 1 }}>
                {t.features.map((f, j) => (
                  <li key={j} style={{ marginBottom: 12, fontSize: 14 }}>✓ {f}</li>
                ))}
              </ul>
              {t.footnote && (
                <p style={{ fontSize: 12, color: 'var(--color-muted)', marginTop: 12 }}>{t.footnote}</p>
              )}
              <a
                href={t.cta.href}
                className="btn-primary btn-primary--block"
                style={{ marginTop: 24, padding: 14 }}
              >
                {t.cta.label}
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
